import KidScientist from './KidScientist';
import { SCENE_CLASSES } from '../../constants/classNames';
import { ASSISTANT_NAME } from '../../constants/config';
import { getFlaskAppearance } from '../../utils/sceneUtils';
import '../../styles/LabScene.css';

// Crop around Fizzy's head and shoulders, with room for the curly hair and ears.
const PORTRAIT_VIEW_BOX = '166 6 148 148';
const EMPTY_FLASK = getFlaskAppearance(null);

/**
 * Fizzy's face, drawn by the same SVG as the lab scene so it always matches.
 */
export default function FizzyPortrait({ size = 64, className }) {
  return (
    <svg
      className={className ?? SCENE_CLASSES.root}
      width={size}
      height={size}
      viewBox={PORTRAIT_VIEW_BOX}
      role="img"
      aria-label={`${ASSISTANT_NAME} the kid scientist`}
    >
      <KidScientist leftFlask={EMPTY_FLASK} rightFlask={EMPTY_FLASK} showArms={false} />
    </svg>
  );
}
